import { flattenEdges, usePaginator } from "@pathwright/utils"
import { useMemo } from "react"
import { CamelCasedProperties } from "type-fest"
import { ContextModelInput, useNotesQuery } from "../api/generated"
import { convertObjectKeysToSnakeCase } from "../utils/convertObjectKeys"

// The ContextModelInput uses snake_case keys but useNotes can accept either snake_case or camelCase.
// So, we expect either in the ContextInput type.
// TODO: localize this type.
export type ContextInput =
  | ContextModelInput
  | CamelCasedProperties<ContextModelInput>

const useNotes = ({
  variables,
  ...queryOptions
}: Parameters<typeof useNotesQuery>[0]) => {
  const notesQuery = useNotesQuery({
    variables: {
      context: convertObjectKeysToSnakeCase(variables?.context),
      visibility: variables?.visibility
    },
    ...queryOptions
  })

  const notes = useMemo(() => {
    if (notesQuery.data) {
      return flattenEdges(notesQuery.data.notes)
    }
  }, [notesQuery.data])

  const { loadMore, hasMore, loadingMore } = usePaginator({
    data: notesQuery, // hacky
    path: "notes"
  })

  return {
    notes,
    loadMore,
    hasMore,
    loadingMore,
    query: notesQuery
  }
}

export default useNotes
